// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8b3753e4","513":"254ec784","703":"69e80667"}[chunkId] + ".chunk.js";
};